export const ACCOUNT = 'account';
export const ORDERS = 'orders';
